import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import ProfileView from "../components/ProfileView";

export default function ProfilePreview() {
  const [profile, setProfile] = useState(null);
  const [strength, setStrength] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get("/profile");
        if (data.profile) {
          setProfile(data.profile);
          setStrength(data.strength || null);
        }
      } catch {}
      setLoading(false);
    };
    load();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
        <div className="text-center">
          <p className="text-[#A3A3A3] mb-4">No profile found. Complete onboarding first.</p>
          <Link to="/onboarding" className="btn-gold text-sm px-4 py-2">START ONBOARDING</Link>
        </div>
      </div>
    );
  }

  return <ProfileView profile={profile} isPreview={true} strength={strength} />;
}
